import { Component } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { ExternalHTMLProvider } from '../../providers/external-html/external-html';

@IonicPage()
@Component({
  selector: 'page-privacy-policy',
  templateUrl: 'privacy-policy.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class PrivacyPolicyPage {

  content: string;
  err: string;
  loading: boolean;

  showAcceptBtn: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public externalHTMLProvider: ExternalHTMLProvider) {}

  closeModal() {
    this.navCtrl.pop();
  }

  ionViewDidLoad() {
    if (this.navParams.get('showAcceptBtn')) {
      this.showAcceptBtn = true;
    }

    let locale:string = this.translate.currentLang;
    let filename:string = `assets/i18n/privacy-policy/${locale}.html`;

    this.loading = true;
    this.externalHTMLProvider.get(filename)
      .subscribe(
        content => this.content = content,
        error => {
          this.externalHTMLProvider.get(`assets/i18n/privacy-policy/en.html`)
          .subscribe(
            content => this.content = content,
            error => {
              this.err = <any>error;
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        },
        () => {
          this.loading = false;
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/pages/privacy-policy/privacy-policy.ts